import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../styles/Developers.css";

const About = () => {
  const navigate = useNavigate();
  const userToken = sessionStorage.getItem("token");

  

  const developers = ["Fariha", "Sarah", "Marcus", "Lorenzo", "Haoyang"];

  return (
    <div className="about-container">
      <h1 className="about-title">Meet Our Developers</h1>
      <p className="about-description">
        Our team is dedicated to creating the best culinary experience for UB students.
        We're passionate about helping you discover great food options on campus.
      </p>
      
      <ul className="developers-list">
        {developers.map((dev) => (
          <li key={dev} className="developer-item">
            <Link to={`/about/${dev.toLowerCase()}`}>
              <h3>{dev}</h3>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default About;
